import React, { useCallback } from 'react';
import FiltersModal from 'utils/components/FiltersModal/FiltersModal';

import './CorporateActionsFiltersModal.scss';
import { useDispatchUpdateFilters } from 'widgets/store/grid/filters/dispatcher';
import { FilterState } from 'widgets/store/grid/filters/FilterState';
import {
    SymbolEventColumn,
    corporateActionsColumnDefinitionsDictionary,
} from 'widgets/corpActions/widget/grid/columnDefinitions';
import { SymbolEvent } from 'widgets/corpActions/data/SymbolEvent';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface CorporateActionsFiltersModalProps {
    data: SymbolEvent[];
    trigger: React.ReactElement;
    visibleColumns: SymbolEventColumn[];
    filters: FilterState<SymbolEventColumn>[];
}

export default function CorporateActionsFiltersModal(
    props: CorporateActionsFiltersModalProps
) {
    const { data, visibleColumns, filters, trigger } = props;

    const dispatchUpdateFilters = useDispatchUpdateFilters();

    const onUpdateFilters = useCallback(
        (nextFilters: FilterState<SymbolEventColumn>[]) => {
            dispatchUpdateFilters(nextFilters);
        },
        [dispatchUpdateFilters]
    );

    const filterFriendlyVisibleColumns = visibleColumns.filter(
        (f) => f !== 'type'
    );

    const { editedColumnNames } = useWidgetEditedColumnNames();

    return (
        <FiltersModal
            columnDefinitions={corporateActionsColumnDefinitionsDictionary}
            visibleColumns={filterFriendlyVisibleColumns}
            editedColumnNames={editedColumnNames}
            filters={filters}
            data={data}
            selectedRowIndexes={[]}
            trigger={trigger}
            onUpdateFilters={onUpdateFilters}
        />
    );
}
